import { render, staticRenderFns } from "./Collections.vue?vue&type=template&id=1b1a05bc&scoped=true&"
import script from "./Collections.vue?vue&type=script&lang=js&"
export * from "./Collections.vue?vue&type=script&lang=js&"
import style0 from "./Collections.vue?vue&type=style&index=0&id=1b1a05bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1a05bc",
  null
  
)

export default component.exports